import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Dossie } from '../models/dossie.model';
import { DossieRepository } from '../repositories/dossie.repository';
import { environment } from '../../../../environments/environment';
import { DossieRequest } from '../models/dossie-request.model';
import { PerfilDossie } from '../models/perfil-dossie.model';
import { DEFAULT_PAGINATION_PARAMS, PaginatedResponse } from '../../../core/shared/models/pagination.model';
import { DossieListParams } from '../models/dossie-list-params.model';

@Injectable({
  providedIn: 'root'
})
export class DossieService implements DossieRepository {
  private readonly apiDossie = 'dossie/';

  constructor(private readonly http: HttpClient) { }

  listarDossies(params: DossieListParams = { ...DEFAULT_PAGINATION_PARAMS }): Observable<PaginatedResponse<Dossie>> {
    let queryParams = new HttpParams()
      .set('page', params.page)
      .set('size', params.size);
    if (params.dossie) queryParams = queryParams.set('dossie', params.dossie);
    if (typeof params.tipoDocumental === 'number') queryParams = queryParams.set('tipoDocumental', params.tipoDocumental);
    if (params.status) queryParams = queryParams.set('status', params.status);

    return this.http.get<PaginatedResponse<Dossie>>(
      `${environment.FI_FINANC_IMOB_BE}${this.apiDossie}listarResumido`,
      { params: queryParams }
    );
  }

  buscarDossiePorId(id: number): Observable<Dossie> {
    return this.http.get<Dossie>(`${environment.FI_FINANC_IMOB_BE}${this.apiDossie}buscar/${id}`);
  }

  criarDossie(payload: DossieRequest): Observable<Dossie> {
    return this.http.post<Dossie>(`${environment.FI_FINANC_IMOB_BE}${this.apiDossie}criar`, payload);
  }

  atualizarDossie(id: number, payload: DossieRequest): Observable<Dossie> {
    return this.http.put<Dossie>(`${environment.FI_FINANC_IMOB_BE}${this.apiDossie}atualizar/${id}`, payload);
  }

  excluirDossie(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.FI_FINANC_IMOB_BE}${this.apiDossie}deletar/${id}`);
  }

  listarPerfisDossie(): Observable<PerfilDossie[]> {
    return this.http.get<PerfilDossie[]>(`${environment.FI_FINANC_IMOB_BE}${this.apiDossie}perfis`);
  }
}
